import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    invoiceCancelDescription: 'Cancel the invoice',
    invoiceCancelTitle: 'This invoice has been declined',
    invoiceDuplicateAndCancelDescription: 'Duplicate the invoice and edit it',
    invoiceDuplicateAndCancelTitle: 'This invoice must be revised',
    invoicePaidTitle: 'This invoice has been paid',
  },
  fr: {
    invoiceCancelDescription: 'Annuler la facture',
    invoiceCancelTitle: 'Cette facture a été refusée',
    invoiceDuplicateAndCancelDescription:
      'Dupliquer la facture et lui apporter des modifications',
    invoiceDuplicateAndCancelTitle: 'Cette facture doit être corrigée',
    invoicePaidTitle: 'Cette facture a été payée',
  },
});
